// extracted by mini-css-extract-plugin
export default {"option":"MovingType_option__hKoMT","selectOption":"MovingType_selectOption__PJ7Vt","optionText":"MovingType_optionText__xHtgQ"};